/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoStore {
    'use strict';

    declare var Z: any;

    class PaymentMethodController {
        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            '$q',
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            'meevo.plugins.meevoStore.MeevoStoreService',
        ];

        constructor(
            protected $scope: angular.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $state: ng.ui.IStateService,
            protected $q: angular.IQService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected storeService: Meevo.Plugins.MeevoStore.IMeevoStoreService,
        ) {
            this.zuoraScriptLoad();
        }

        get isZuoraScriptLoad () {
            return typeof Z !== 'undefined';
        }

        zuoraScriptLoad () {
            console.log('zuoraScriptLoad');
            if (this.isZuoraScriptLoad) {
                this.loadHostedPage();
            } else {
                this.loadScript('https://static.zuora.com/Resources/libs/hosted/1.3.0/zuora-min.js', this.loadHostedPage);
            }
        }

        loadScript(src: string, callback: Function){
            var script = document.createElement("script");
            script.type = "text/javascript";
            if(callback)script.onload=callback.bind(this);
            console.log(script);
            document.getElementsByTagName("head")[0].appendChild(script);
            script.src = src;
        }

        forwardCallbackURL(response: any) {
            /*
            var callbackUrl = "<%=request.getContextPath()%>/callback?";
            for(id in response) {
                callbackUrl = callbackUrl+id+"="+encodeURIComponent(response[id])+"&";
            }
            window.location.replace(callbackUrl);
            */
        }

        callback (response) {
            if(!response.success) {
                // Requesting Payment Page failed. Error handling code should be added here. Simply forward to the callback url in sample code.
                // forwardCallbackURL(response);
            }
        };

        loadHostedPage() {
            this.dataService.customMethodData('api/MeevoStore/Zuora/Signature', 'GET', {}).then((data) => {
                let response = data.data;
                let params = {
                    tenantId: response.tenantId,
                    id: response.pageId, // pageId
                    token: response.token,
                    signature: response.signature,
                    style: "inline",
                    key: response.key,
                    submitEnabled: "true",
                    locale: "en_EN",
                    url: response.hostedPageUri,
                    paymentGateway: "Millennium SI Gateway", // payment gateway name
                    field_gatewayName: "Millennium SI Gateway", // payment gateway name
                    field_accountId: '2c92c0f962ae1df20162aedb1ba9423d',
                };
                let prepopulateFields = {
                    creditCardAddress1:"123 Any Street",
                    creditCardAddress2:"Suite #999",
                    creditCardCountry:"USA",
                    creditCardHolderName:"John Doe"
                };

                Z.render(
                    params,
                    prepopulateFields,
                    this.callback
                );
            });
        }

        processBtn () {
            Z.submit();
        }
    }
    angular.module('meevo.plugins.meevoStore')
        .controller('meevo.plugins.meevoStore.PaymentMethodController', PaymentMethodController);
}